<template>
	<view class="store">
		<view class="store_list">
			<view class="store_list_item" @click="toDetails">
				<image src="@/static/uni.png" mode="widthFix"></image>
				<view class="store_list_item_right">
					<text class="store_list_item_right_title">
						<text>标题标题标题标题标题标题标题标题标题标题标题标题</text>
					</text>
					<uni-rate active-color="#D20A0A" :readonly="true" :value="5" />
					<text class="store_list_item_right_address">江宁路街道陕西北路</text>
					<view class="store_list_item_right_list">
						<view class="store_list_item_right_list_item">有大桌子</view>
						<view class="store_list_item_right_list_item">有大桌子</view>
					</view>
				</view>
			</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		},
		onLoad() {
			
		},
		methods: {
			toDetails() {
				uni.navigateTo({
					url: '/pages/storeDetails/index'
				});
			}
		}
	}
</script>

<style>
	page {
		background-color: #ffffff;
	}
</style>

<style lang="scss" scoped>
	.store {
		width: 100%;
		padding: 32rpx;
		box-sizing: border-box;
		.store_list {
			width: 100%;
			display: flex;
			flex-direction: column;
			flex-wrap: wrap;
			.store_list_item {
				flex: 1;
				height: 172rpx;
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-bottom: 52rpx;
				&:last-child {
					margin-bottom: 0 !important;
				}
				image {
					width: 172rpx;
					height: 172rpx;
					margin-right: 16rpx;
					flex-shrink: 0;
				}
				.store_list_item_right {
					flex: 1;
					height: 100%;
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					.store_list_item_right_title {
						width: 500rpx;
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
						text {
							font-size: 28rpx;
							font-family: PingFang SC-Semibold, PingFang SC;
							font-weight: 600;
							color: #333333;
						}
					}
					.store_list_item_right_address {
						font-size: 24rpx;
						font-family: PingFang SC-Regular, PingFang SC;
						font-weight: 400;
						color: #999999;
					}
					.store_list_item_right_list {
						width: 100%;
						display: flex;
						align-items: center;
						flex-wrap: wrap;
						.store_list_item_right_list_item {
							padding: 4rpx 6rpx;
							background: #F5F4F5;
							border-radius: 4rpx;
							font-size: 22rpx;
							font-family: PingFang SC-Regular, PingFang SC;
							font-weight: 400;
							color: #333333;
							margin-left: 12rpx;
							&:first-child {
								margin-left: 0 !important;
							}
						}
					}
				}
			}
		}
	}
</style>